<div class="login-div">
    <div class="graphic-logoimg">
        <img src="../../../../assets/images/leaf-wht-big.png" alt="logo">
    </div>
    <div class="graphic-img">
        <img src="../../../../assets/images/leaf-orange-big2.png" alt="graphic">
    </div>
    <div class="login-container">
        <div class="login-left">
            <div class="login-controls-section">
                <img src="../../../../assets/images/fciLogo.svg" alt="Logo">
                <div class="form-group">
                    <label>Enter Email</label>
                    <input type="text" placeholder="Email" class="form-control" value="" autocomplete="off">
                </div>
                <div class="form-group">
                    <label>Enter Password</label>
                    <input type="" placeholder="Atleast 8 Characters" class="form-control password">

                    <a class="passwordshowbtn">
                        <i class="icon-eye-slash" aria-hidden="true"></i>
                    </a>
                </div>
                <input type="submit" class="login-btn " value="SIGN IN"  [routerLink]='["/management-login/management-dashboard"]'>
            </div>

        </div>
    </div>


</div>